import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'full';
}
export function Modal({
  isOpen,
  onClose,
  title,
  children,
  footer,
  size = 'md'
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  // Account for tab bar (80px) in height calculations
  const sizeStyles = {
    sm: 'max-h-[calc(50vh-80px)]',
    md: 'max-h-[calc(70vh-80px)]',
    lg: 'max-h-[calc(90vh-80px)]',
    full: 'h-[calc(100%-80px)]'
  };
  return <AnimatePresence data-id="element-367">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/40 z-[60]" data-id="element-368" />

          <motion.div initial={{
        y: '100%'
      }} animate={{
        y: 0
      }} exit={{
        y: '100%'
      }} transition={{
        type: 'spring',
        damping: 30,
        stiffness: 300
      }} style={{
        bottom: '80px'
      }} className={`fixed left-0 right-0 bg-white rounded-t-3xl z-[60] flex flex-col ${sizeStyles[size]}`} data-id="element-369">
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b border-sand flex-shrink-0" data-id="element-370">
              {title && <h2 className="text-lg font-semibold text-charcoal" data-id="element-371">{title}</h2>}
              <button onClick={onClose} className="ml-auto p-2 hover:bg-sand rounded-full transition-colors" data-id="element-372">
                <X size={24} className="text-charcoal" data-id="element-373" />
              </button>
            </div>

            {/* Scrollable Content */}
            <div className="overflow-y-auto p-4 flex-1 min-h-0" data-id="element-374">{children}</div>

            {/* Fixed Footer */}
            {footer && <div className="p-4 border-t border-sand flex-shrink-0 bg-white rounded-b-none" data-id="element-375">
                {footer}
              </div>}
          </motion.div>
        </>}
    </AnimatePresence>;
}